@if (HasRequiredPermissions) {

<div class="bg-white p-6 rounded-lg shadow w-full max-w-none" [class.my-8]="!isNested" [class.my-4]="isNested">
  <div class="mb-6">
    <h1 class="text-lg font-medium text-gray-700 mb-4" data-testid="list-title">
      {{ `entities.${entityMetaData.EntityName.toLowerCase()}.pluralName` | translate }} ({{ totalSeen }}/{{
      listView()?.entities()?.total
      }})
    </h1>
  </div>
  <app-list-view [entityType]="ComponentEntityClass"
    [contextMenuItems]="contextMenuItems"
    [showActions]="true"
    [canEdit]="canEdit.bind(this)"
    (entitySelected)="selectSingleItem($event)"
    (editAction)="editSelectedItem($event)"
    (deleteAction)="deleteSelectedItem($event)"
    [dismissEntity]="dismissEntityState.bind(this)"
    [onDismissAdded]="dismissEntityState.bind(this)"
    [onRowDismiss]="handleRowDismiss.bind(this)"
    [pagination]="{
                          enabled: true,
                          pageLengths: [5, 10, 20, 50, 100, 300],
                          defaultPageLength: 5,
                          searchColumns: null,
                          sortableColumns: null
                        }"
    [paginatorType]="'button'"
    [showHeader]="false"
    (createButtonClick)="openCreateModal()">
    <!-- Colonne FullName -->
    <app-list-table-column key="name" title="{{ 'entities.account.propreties.name' | translate }}" type="text"
      [sortable]="true" align="left"></app-list-table-column>
    <!-- Colonne POS -->
    <app-list-table-column key="accountPOS" title="{{ 'entities.account.propreties.pos' | translate }}" type="custom">
      <ng-template #customTemplate let-entity>
        <div class="flex flex-wrap gap-1">
          @for (ep of entity.accountPOS; track ep.fK_POS) {
          <app-reactive-badge
            [status]="ep.fK_POS"
            [lookupData]="getPosBadgeLookup(ep)"
            [Skin]="Skin"
            [isEditMode]="false">
          </app-reactive-badge>
          }
        </div>
      </ng-template>
    </app-list-table-column>
    <app-list-table-column key="email" title="{{ 'entities.account.propreties.email' | translate }}" type="text"
      [sortable]="true" align="left"></app-list-table-column>
    <!-- Colonne Role -->
    <app-list-table-column key="fK_Role" title="{{ 'entities.account.propreties.role' | translate }}" type="custom"
      align="left">
      <ng-template #customTemplate let-entity>
        <span class="text-gray-700">{{ getRoleTitle(entity) }}</span>
      </ng-template>
    </app-list-table-column>
    <!-- Colonne EditPermissions -->
    <app-list-table-column key="notify" title="{{ 'vues.account.list.columns.editPermissions' | translate }}"
      type="custom">
      <ng-template #customTemplate let-entity>
        <app-reactive-badge [lookupData]="editPermissionsLookupArray" [status]="1" [Skin]="Skin" [isEditMode]="true"
          (statusChange)="doSpecialAction(entity,  'editPermissions', $event)"></app-reactive-badge>
      </ng-template>
    </app-list-table-column>
  </app-list-view>
  <div class="fixed top-0 right-0 h-full z-50 min-w-[350px]"
    [style.width.px]="currentWidth()"
    [hidden]="!isModalOpen()">

    <!-- Poignee interactive (invisible avant le survol)  -->
    <div class="absolute left-0 top-0 h-full w-2 hover:w-3 hover:bg-gray-600 hover:shadow-md cursor-[ew-resize] transition-all z-[999]"
      (mousedown)="startResize($event)">
    </div>
    <div class="bg-white h-full rounded-lg shadow-xl p-1">
      <app-tenant-account-detail #accountDetail [isModal]="true" [dataService]="dataService" (closeModal)="closeModal($event)"
        (itemSaved)="onItemUpdated($event)" (databaseUpdated)="closeModal(true)" [EntityInstance]="selectedItem()"
        [fkPointOfServiceId]="fkPointOfServiceId">
      </app-tenant-account-detail>
    </div>
  </div>

  <div class="fixed top-0 right-0 h-full z-50 min-w-[350px]"
    [style.width.px]="currentWidth()"
    [hidden]="!isPermissionModalOpen()">

    <!-- Poignee interactive (invisible avant le survol)  -->
    <div class="absolute left-0 top-0 h-full w-2 hover:w-3 hover:bg-gray-600 hover:shadow-md cursor-[ew-resize] transition-all z-[999]"
      (mousedown)="startResize($event)">
    </div>

    <div class="bg-white h-full rounded-lg shadow-xl p-1">
      <app-permissions-detail #roleDetail [isModal]="true" [dataService]="dataService"
        (closeModal)="closePermissionModal()" (itemSaved)="onItemUpdated($event)"
        (databaseUpdated)="closePermissionModal()" [EntityInstance]="selectedItem()"
        [fkPointOfServiceId]="fkPointOfServiceId">
      </app-permissions-detail>
    </div>
  </div>
</div>
}